var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationPurpoleStarCion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8327 9.76996C4.72872 10.0767 4.27123 10.0767 4.1673 9.76996C3.86577 8.87933 3.37179 7.66435 2.73693 6.95895C2.10209 6.25354 1.00855 5.7046 0.207176 5.36964C-0.0690584 5.2541 -0.0690584 4.74583 0.207176 4.63029C1.00855 4.29534 2.10209 3.7464 2.73693 3.04099C3.3718 2.33558 3.86577 1.12061 4.1673 0.230235C4.27123 -0.0767458 4.72872 -0.0767458 4.8327 0.230235C5.13417 1.12061 5.62821 2.33558 6.26307 3.04099C6.89793 3.7464 7.9914 4.29534 8.79296 4.63029C9.06901 4.74583 9.06901 5.2541 8.79296 5.36964C7.9914 5.7046 6.89793 6.25354 6.26307 6.95895C5.62821 7.66435 5.13416 8.87933 4.8327 9.76996Z",
    fill: "#9B5DE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationPurpoleStarCion);
export default __webpack_public_path__ + "static/media/reservation-purpole-star-cion.6297b32096634ee830d246e9f1875a50.svg";
export { ForwardRef as ReactComponent };